// libraries.
import { Badge } from 'react-bootstrap';

// interfaces.
import { ApproverTaskItem } from '../../../../../domains/approver-review/interfaces/interfaces';
import { useSelector } from 'react-redux';
import { RefetchButton } from './RefetchButton';

export const PendingTasks = ({
  tasks,
  refetch,
  isFetching,
}: {
  tasks: ApproverTaskItem[];
  refetch: () => void;
  isFetching: boolean;
}) => {
  const user = useSelector((state: any) => state.userStore.user);

  const pendingGlobal = tasks.filter(task => task.status === 'pending');
  const pendingByUser = pendingGlobal.filter(
    task => task.agent === user?.email
  );

  return (
    <div className="wrapper-tasks">
      <div className="d-flex justify-content-between align-items-center p-3">
        <div className="d-flex gap-3 align-items-center">
          <div className="d-flex gap-2 align-items-center">
            <strong className="fw-bold">Tareas sin completar</strong>
            <Badge className="tasks">{pendingGlobal.length}</Badge>
          </div>
          <div className="d-flex gap-2 align-items-center">
            <strong className="fw-bold">Mis tareas</strong>
            <Badge className="tasks">{pendingByUser.length}</Badge>
          </div>
        </div>
        <RefetchButton onRefetch={refetch} isLoading={isFetching} />
      </div>
    </div>
  );
};
